import axios from "axios";
import 'react-dropzone-uploader/dist/styles.css'

import { get_media } from "../../../../api/api";
import { mediaUpload } from './../../../../api/api';

const UploadGallery = ({ havePoster, pullback, setLoading, images }) => {


      const removeFile = (id) => {
            const newFiles = [...images]
            newFiles.splice(newFiles.indexOf(id), 1)
            pullback(newFiles)
      }

      const handleGalleryForm = async (e) => {
            const fileList = e.target.files
            const files = [...fileList]

            try {
                  for (let index = 0; index < files.length; index++) {
                        const file = files[index];
                        const formData = new FormData();
                        formData.append("file", file);
                        let images_copy = images
                        setLoading(true)
                        const res = await axios.post(mediaUpload, formData);
                        images_copy.push(res.data.mediaId)
                        pullback(images_copy)
                  }
            } catch (err) {
                  return false
            } finally {
                  setLoading(false)
            }


      }


      return (
            <div className="galleryUpload">


                  <div className="galleryUpload">
                        <div className="dzu-dropzone">

                              {images.length > 0 ?
                                    <>
                                          {images.map(item => (
                                                <div key={item} className="dzu-previewContainer">
                                                      <img className="dzu-previewImage" src={get_media(item)} />
                                                      <div className="dzu-previewStatusContainer">
                                                            <span className="dzu-previewButton" onClick={() => removeFile(item)} style={{ backgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUuMCwgMC4wKSIgZmlsbD0iIzMzMzMzMyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4wLCAwLjApIj48cG9seWdvbiBwb2ludHM9IjcuNzE5IDQuOTY0IDEyLjY5MiAwLjAxNyAxNC4zODkgMS43MTUgOS40MTIgNi42NjYgMTQuMzU0IDExLjYzNCAxMi42NTcgMTMuMzMxIDYuMDE3IDYuNjU3IDcuNzE1IDQuOTYwIj48L3BvbHlnb24+PHBvbHlnb24gcG9pbnRzPSI3LjYxMiA0Ljk2NCA3LjYxNiA0Ljk2MCA5LjMxMyA2LjY1NyAyLjY3NCAxMy4zMzEgMC45NzcgMTEuNjM0IDUuOTE5IDYuNjY2IDAuOTQyIDEuNzE1IDIuNjM5IDAuMDE3Ij48L3BvbHlnb24+PC9nPjwvZz48L3N2Zz4K)' }}></span>
                                                      </div>
                                                </div>
                                          ))}

                                          <label className="dzu-inputLabelWithFiles" style={{ fontFamily: 'IRANSansWeb,Arial' }}>افزودن تصویر<input onChange={handleGalleryForm} className="dzu-input" type="file" accept="image/png,image/jpg" multiple={true} /></label>
                                    </>
                                    :

                                    <label className="dzu-inputLabel">گالری تصویر<input onChange={handleGalleryForm} className="dzu-input" type="file" accept="image/png,image/jpg" multiple={true} />
                                    </label>
                              }
                        </div>
                  </div>

            </div>
      )
}
export default UploadGallery